import gql from 'graphql-tag';
import * as Apollo from '@apollo/client';
import * as Types from '../../../../../server/graphql/__generated.types';

const defaultOptions = {} as const;
export type GetLlmPronunciationSuggestionsMutationVariables = Types.Exact<{
  inputs: Types.LlmPronunciationSuggestionInputs;
}>;

export type GetLlmPronunciationSuggestionsMutation = {
  __typename?: 'Mutation';
  llmPronunciationSuggestion: {
    __typename?: 'LlmPronunciationSuggestionResponse';
    code: string;
    success: boolean;
    message: string;
    suggestions: Array<{
      __typename?: 'LlmPronunciationSuggestion';
      pronunciation: string;
    }>;
  };
};

export const GetLlmPronunciationSuggestionsDocument = gql`
  mutation getLLMPronunciationSuggestions($inputs: LlmPronunciationSuggestionInputs!) {
    llmPronunciationSuggestion(inputs: $inputs) {
      code
      success
      message
      suggestions {
        pronunciation
      }
    }
  }
`;
export type GetLlmPronunciationSuggestionsMutationFn = Apollo.MutationFunction<
  GetLlmPronunciationSuggestionsMutation,
  GetLlmPronunciationSuggestionsMutationVariables
>;

/**
 * __useGetLlmPronunciationSuggestionsMutation__
 *
 * To run a mutation, you first call `useGetLlmPronunciationSuggestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetLlmPronunciationSuggestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getLlmPronunciationSuggestionsMutation, { data, loading, error }] = useGetLlmPronunciationSuggestionsMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *   },
 * });
 */
export function useGetLlmPronunciationSuggestionsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    GetLlmPronunciationSuggestionsMutation,
    GetLlmPronunciationSuggestionsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    GetLlmPronunciationSuggestionsMutation,
    GetLlmPronunciationSuggestionsMutationVariables
  >(GetLlmPronunciationSuggestionsDocument, options);
}
export type GetLlmPronunciationSuggestionsMutationHookResult = ReturnType<
  typeof useGetLlmPronunciationSuggestionsMutation
>;
export type GetLlmPronunciationSuggestionsMutationResult =
  Apollo.MutationResult<GetLlmPronunciationSuggestionsMutation>;
export type GetLlmPronunciationSuggestionsMutationOptions = Apollo.BaseMutationOptions<
  GetLlmPronunciationSuggestionsMutation,
  GetLlmPronunciationSuggestionsMutationVariables
>;
